import { FC } from "react";

import { useFormContext } from "react-hook-form";

import { AutomatedCommunicationCard } from ".././components/AutomatedCommunicationCard";
import { AutomatedCommunicationsFormData, RowKey } from "../types";

import { useTranslate } from "@/common/hooks/useTranslate";

interface ThankYouBidPlacedCardProps {
  openRow: RowKey | null;
  onToggleOpen: (row: RowKey) => void;
  isSmsEnabled: boolean;
  defaultContent: string;
}

export const ThankYouBidPlacedCard: FC<ThankYouBidPlacedCardProps> = ({
  openRow,
  onToggleOpen,
  isSmsEnabled,
  defaultContent,
}) => {
  const { t } = useTranslate();
  const form = useFormContext<AutomatedCommunicationsFormData>();
  return (
    <AutomatedCommunicationCard<AutomatedCommunicationsFormData>
      label={t("dashboard", "ticketing.automatedCommunications.row.thankYouBidPlaced.label")}
      control={form.control}
      errors={form.formState.errors}
      dataEmailType="thank-you-bid-placed"
      fields={{ subject: "thankYouBidPlaced.subject", content: "thankYouBidPlaced.content" }}
      enabled
      lockedOn
      toggleTooltip={t("dashboard", "ticketing.automatedCommunications.row.thankYouBidPlaced.lockedTooltip")}
      chip={{
        label: t("dashboard", "ticketing.automatedCommunications.trigger.whenBidSubmitted"),
        showWhen: "enabled",
      }}
      collapse={{
        isOpen: openRow === "thank-you-bid-placed",
        onToggle: () => onToggleOpen("thank-you-bid-placed"),
      }}
      channelIcons={isSmsEnabled ? { email: true, sms: false } : undefined}
      body={{ defaultValue: defaultContent }}
      dataTestPrefix="thank-you-bid-placed"
    />
  );
};
